import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { LoadingSpinner } from "components/common";
import PIFForm from "../pif/PIFForm";
import { getChangeOrderRevision, updateRevisionPIF } from "redux/crm/project/changeOrderRevisionSlice";

// The only route a revision has: the PIF editor. Everything else about a
// revision lives in the drawer on the CO detail page, but the PIF form (GDS +
// BDS1/2/3 per area) needs a full screen — same as the normal PIF editor.
const RevisionPIFEdit = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const projectId = params.project_id;
  const buildingId = params.building_id;
  const changeOrderId = params.change_order_id;
  const revisionId = params.revision_id;

  const { record: revision, loading } = useSelector(state => state.crm_change_order_revision);
  const parent = revision?.parent || {};

  useEffect(() => {
    dispatch(getChangeOrderRevision({ projectId, buildingId, changeOrderId, revisionId }));
  }, [projectId, buildingId, changeOrderId, revisionId, dispatch]);

  // Back to the CO detail with this revision's drawer reopened.
  const backUrl = `/crm/projects/${projectId}/buildings/${buildingId}/change-orders/${changeOrderId}?revision=${revisionId}`;

  const handleSave = async (result, { saveAndClose }) => {
    try {
      await dispatch(updateRevisionPIF({
        projectId, buildingId, changeOrderId, revisionId, data: result
      })).unwrap();

      if (saveAndClose) navigate(backUrl);
    }
    catch (error) {
      toast.error(error?.error || error?.message || 'Failed to save the PIF.');
    }
  };

  const isCurrent = revision?.id === Number(revisionId) || revision?.id === revisionId;

  if (!isCurrent || loading) return <LoadingSpinner message="Loading revision PIF..." />;

  if (!revision?.has_pif) {
    return (
      <div className="tw-text-sm tw-text-slate-500 tw-p-4">
        REV#{revision?.rev} has no PIF. Clone one from CO#{parent.co} first.
      </div>
    );
  }

  return (
    <PIFForm
      project={parent.project}
      building={parent.building}
      adaptation={{ id: changeOrderId, co: parent.co, type: 'change_order' }}
      pif={revision.pif}
      title={`Edit PIF of REV#${revision.rev} (CO#${parent.co})`}
      isPIFversion={false}
      onSave={handleSave}
    />
  );
};

export default RevisionPIFEdit;
